import React from 'react';
import TeamsTable from './TeamsTable';
import {Link} from 'react-router';
import confirm from 'utils/confirm';
import 'styles/admin/TeamsPage.styl';

export default class DepartmentTeams extends React.PureComponent {
  onCommitTeamMove = () => {
    const {
      TeamListStore: {
        teamStagedForMove: team,
        departmentStagedToReceive: receive,
        departmentStagedToRemoveFrom: remove,
      },
      TeamActions,
    } = this.props;
    const message = `
      Are you sure you want to move team "${team.name}" from
      "${remove.name}" to "${receive.name}"?`;
    confirm(message, 'Move team?').then(
      () => TeamActions.commitTeamMove(team.set('departmentId', receive.id)),
      TeamActions.discardTeamMove
    );
  };

  render() {
    const {TeamListStore, TeamActions, department, departmentProfiles, showTeamDialog} = this.props;
    const {id, name} = department;
    const teams = TeamListStore.departmentTeams.get(id);
    return teams && teams.size > 0 ? (
      <section key={id} className="department">
        <div className="header">
          <h3>
            <Link to={`/admin/departments/edit/${id}`}>{name}</Link>
          </h3>
        </div>
        {TeamListStore.departmentTeamErrors.get(id) ? (
          'Error fetching teams.'
        ) : (
          <TeamsTable
            teams={teams}
            showTeamDialog={showTeamDialog}
            onStageTeamForMove={TeamActions.stageTeamForMove}
            onStageDepartmentToReceive={TeamActions.stageDepartmentToReceive}
            onCommitTeamMove={this.onCommitTeamMove}
            onDiscardTeamMove={TeamActions.discardTeamMove}
            teamStagedForMove={TeamListStore.teamStagedForMove}
            departmentStagedToReceive={TeamListStore.departmentStagedToReceive}
            departmentStagedToRemoveFrom={TeamListStore.departmentStagedToRemoveFrom}
            department={department}
            departments={departmentProfiles}
            TeamMoveDialogActions={this.props.TeamMoveDialogActions}
            onDeleteTeam={TeamActions.deleteTeam}
          />
        )}
      </section>
    ) : null;
  }
}
